export const replaceUndefinedWithEmptyString = <T extends object>(obj: T): T => {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  const copy: any = Array.isArray(obj) ? [...obj] : { ...obj };

  Object.keys(copy).forEach((key) => {
    const value = copy[key];
    if (typeof value === "object" && value !== null) {
      copy[key] = replaceUndefinedWithEmptyString(value);
    } else if (value === undefined) {
      copy[key] = "";
    }
  });

  return copy;
};
